import { defineMessages } from 'react-intl-next';

export const i18n: {
    summarizeInChatButtonText: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	summarizeInChatButtonText: {
		id: 'summarize-in-chat-button-text',
		defaultMessage: 'Summarize',
		description: 'Text for the button that summarizes the page in chat',
	},
});
